import { Link } from "react-router-dom";
import { PricingSection, SiteFooter } from "@/pages/Landing";
import Logo from "@/components/Logo";

export default function Pricing() {
  return (
    <div className="min-h-screen bg-background text-foreground" data-testid="pricing-page">
      <header className="border-b border-border bg-card sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <Logo variant="wordmark" size={32} to="/" testId="pricing-logo" />
          <div className="flex items-center gap-3">
            <Link to="/login" className="text-sm text-muted-foreground hover:text-foreground font-medium hidden sm:inline">Sign in</Link>
            <Link to="/request-access" className="text-sm bg-primary text-primary-foreground rounded-lg px-4 py-2 font-semibold hover:bg-primary/90 transition-colors" data-testid="pricing-cta">Request Access</Link>
          </div>
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 sm:pt-16">
        <div className="text-overline text-primary mb-3">Software Plans</div>
        <h1 className="font-display text-3xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] max-w-3xl">
          Simple subscription pricing for market intelligence software
        </h1>
        <p className="mt-5 text-sm sm:text-base text-muted-foreground max-w-2xl">
          Every plan is a self-serve monthly or annual software subscription. Instant activation. Cancel any time from inside the platform.
        </p>
      </div>

      <PricingSection />

      <section className="border-b border-border">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20 grid grid-cols-1 sm:grid-cols-3 gap-4">
          {[
            { t: "Instant activation",  d: "Sign up, subscribe, and access the full software the same minute. No offline missions, no bespoke deliverables." },
            { t: "Flexible payment",    d: "Cards, mobile money and bank transfer — processed securely by Paystack. Enterprise volume via our sales team." },
            { t: "Procurement-ready",   d: "Custom MSAs, DPAs and invoicing available on the Advanced plan. All contracts are for software access — not for services." },
          ].map((b) => (
            <div key={b.t} className="bg-card border border-border rounded-xl p-6">
              <div className="font-display text-lg tracking-tight">{b.t}</div>
              <div className="text-sm text-muted-foreground mt-2 leading-relaxed">{b.d}</div>
            </div>
          ))}
        </div>
      </section>

      <SiteFooter />
    </div>
  );
}
